import React, { useEffect, useMemo, useState } from "react";
import { MapContainer, TileLayer, ZoomControl, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import axiosInstance from "../../lib/auth/axiosApi";
import SkyLayers, { BASEMAPS } from "./SkyLayers";

const HOURS = 24 * 7;
const ALL_LAYERS = { drones: true, sky: true, alpr: true, mycams: true, nodes: true };

// Keep the activity out from under the pitch: on wide screens the headline
// covers the left ~half, on phones the top ~half.
function Fit({ points }) {
  const map = useMap();
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (done || !points.length) return;
    setDone(true);
    const size = map.getSize();
    const wide = size.x > 900;
    map.fitBounds(L.latLngBounds(points).pad(0.15), {
      paddingTopLeft: wide ? [Math.min(760, size.x * 0.5), 80] : [30, size.y * 0.55],
      paddingBottomRight: wide ? [280, 80] : [30, 40],
      maxZoom: 14,
    });
  }, [map, points, done]);
  return null;
}

// The homepage hero: the same public map as the big view, last 7 days, no sidebar.
function PublicMap() {
  const [data, setData] = useState({ nodes: [], drones: [], sky: [], cameras: [] });

  useEffect(() => {
    let alive = true;
    const load = () =>
      axiosInstance
        .get(`skywatch/map/?hours=${HOURS}`)
        .then((res) => alive && setData(res.data))
        .catch(() => {});
    load();
    const t = setInterval(load, 60 * 1000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  const points = useMemo(
    () => [
      ...data.drones.flatMap((d) => d.points.map((p) => [p[0], p[1]])),
      ...data.nodes.map((n) => [n.lat, n.lon]),
      ...data.cameras.filter((c) => c.latitude != null).map((c) => [c.latitude, c.longitude]),
    ],
    [data]
  );

  return (
    <MapContainer
      center={[39.5, -98.35]}
      zoom={4}
      scrollWheelZoom={false}
      dragging={!L.Browser.mobile}
      tap={false}
      zoomControl={false}
      style={{ height: "100%", width: "100%", background: "#0e0e16" }}
    >
      <TileLayer url={BASEMAPS.dark.url} attribution={BASEMAPS.dark.attribution} maxZoom={19} />
      <TileLayer url={BASEMAPS.dark.ref} maxZoom={19} />
      <Fit points={points} />
      {!L.Browser.mobile && <ZoomControl position="bottomright" />}
      <SkyLayers data={data} layers={ALL_LAYERS} />
    </MapContainer>
  );
}

export default PublicMap;
